/**
 * FPR Team types for Flashpoint Race game mode
 *
 * Teams consist of 4 players: 1 Team Lead + 3 Members
 * Team Leads are selected by the admin
 * Team Leads select their own team members
 * Teams must be locked before the game can begin
 */
// ============================================================================
// Team Configuration
// ============================================================================
/**
 * Team size requirements
 */
export const FPR_TEAM_SIZE = 4;
export const FPR_MIN_MEMBERS = 1; // At minimum, just the lead
// ============================================================================
// Helper Functions
// ============================================================================
/**
 * Check if a team is complete (has 4 members)
 */
export function isTeamComplete(team) {
    return team.members.length >= FPR_TEAM_SIZE;
}
/**
 * Check if a team is ready to be locked
 */
export function isTeamReady(team) {
    return team.status === 'ready' || isTeamComplete(team);
}
/**
 * Get the team lead member from a team
 */
export function getTeamLead(team) {
    return team.members.find((m) => m.role === 'lead');
}
/**
 * Get regular members (non-leads) from a team
 */
export function getTeamMembers(team) {
    return team.members.filter((m) => m.role === 'member');
}
/**
 * Check if a player is in a specific team
 */
export function isPlayerInTeam(team, playerId) {
    return team.members.some((m) => m.playerId === playerId);
}
/**
 * Check if a player is a team lead
 */
export function isTeamLead(team, playerId) {
    return team.leadPlayerId === playerId;
}
/**
 * Find which team a player belongs to
 */
export function findPlayerTeam(teams, playerId) {
    return teams.find((team) => isPlayerInTeam(team, playerId));
}
/**
 * Check if all teams are locked
 */
export function areAllTeamsLocked(teams) {
    return teams.length > 0 && teams.every((t) => t.status === 'locked');
}
/**
 * Check if all teams are ready to be locked
 */
export function areAllTeamsReady(teams) {
    return teams.length > 0 && teams.every((t) => isTeamReady(t));
}
/**
 * Get count of remaining slots in a team
 */
export function getTeamOpenSlots(team) {
    return Math.max(0, FPR_TEAM_SIZE - team.members.length);
}
